import { DirectSignupFiltersFormType } from 'domains/signupDirect/schemas/filtersSchema';
import { DIRECT_SIGNUP_MIXPANEL_EVENTS } from 'domains/signupDirect/misc/mixpanelTracking';
import { toStateFull } from 'utils/states';

type TrackFunction = (event: string, properties: Record<string, unknown>) => void;

const PRIVATE_PAY = 'Private Pay';
const OTHER_INSURANCE = 'Other Insurance';

export const trackURLFilters = (
  track: TrackFunction,
  filtersFromURL: DirectSignupFiltersFormType,
  isResumedLead: boolean,
) => {
  if (!filtersFromURL.paymentMethod) return;

  // Track detailed event with state information and payment method details
  const trackingProperties: Record<string, string> = {
    stateName: toStateFull(filtersFromURL.stateCode) || 'Unknown',
  };

  const paymentMethodType = filtersFromURL.paymentMethod.type;

  let trackingEvent = '';

  if (paymentMethodType === 'insurance') {
    trackingEvent = DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.URL_FILTERS_DETAILS.HAS_INSURANCE;
    trackingProperties.insuranceName = filtersFromURL.paymentMethod.insuranceData?.friendlyPayerName ?? '';
    trackingProperties.insuranceType = filtersFromURL.paymentMethod.insuranceData?.insuranceType ?? '';
  } else if (paymentMethodType === 'privatePay') {
    trackingEvent = DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.URL_FILTERS_DETAILS.HAS_NO_INSURANCE;
    trackingProperties.paymentMethodName = PRIVATE_PAY;
  } else if (paymentMethodType === 'otherInsurance') {
    trackingEvent = DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.URL_FILTERS_DETAILS.HAS_NON_LISTED_INSURANCE;
    trackingProperties.paymentMethodName = OTHER_INSURANCE;
  } else {
    // Defensive check, should not happen
    return;
  }

  track(trackingEvent, { isResumedLead, ...trackingProperties });
};
